import { useTranslation } from "next-i18next";

import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";

import { UtilitySectionData } from "./types";

import CommonStyled from "../index.styles";
import UtilityCardList from "./UtilityCardList";
import Styled from "./index.styles";

export default function LandingSectionUtility({
  data,
  backgroundColor = COLOR.wh,
}: {
  data: UtilitySectionData[];
  backgroundColor?: string;
}) {
  const { t } = useTranslation(["components"]);

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.sectionUtility ref={target} backgroundColor={backgroundColor}>
      <Styled.container>
        <div className="section-title-wrapper">
          <CommonStyled.sectionTitle
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            {t("components:landing.이외_편의_서비스를_제공하고_있습니다.")}
          </CommonStyled.sectionTitle>
        </div>

        <UtilityCardList data={data} isActiveTarget={isActivatedTarget} />
      </Styled.container>
    </Styled.sectionUtility>
  );
}
